/* SUGAR BROWED · THE GOLDEN SEASON 2026 · campaign layer (temporary).
   Decorative overlays only: no product data, prices, links or forms are changed. */
(function () {
  var C = window.GSC;
  if (!C) return;
  var now = Date.now();
  if (now < Date.parse(C.start) || now > Date.parse(C.end)) return;

  var SKIP = '.nmpd-gallery, .nmpd-upsell, header, .header, nimbus-cart-drawer, cart-drawer, .cart-drawer, #CartDrawer, .predictive-search, predictive-search, .gsc-band';

  function handleOf(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }
  function isFull(h) { return !!h && C.full.indexOf(',' + h + ',') !== -1; }

  function makeLabel(large) {
    var img = new Image();
    img.src = large ? C.labelLarge : C.label;
    img.alt = C.alt;
    img.className = 'gsc-label' + (large ? ' gsc-label--pdp' : '');
    img.loading = 'lazy';
    img.decoding = 'async';
    img.draggable = false;
    img.width = 400; img.height = 400;
    return img;
  }

  /* 1 · labels on product cards (collections, search, featured, related ...) */
  function labelCards() {
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var n = 0; n < links.length; n++) {
      var a = links[n];
      if (a.closest(SKIP)) continue;
      var h = handleOf(a.getAttribute('href'));
      if (!isFull(h)) continue;
      var img = a.querySelector('img:not(.gsc-label)');
      if (!img) {
        var card = a.closest('article, li, .sb-card, [class*="card"]');
        img = card && card.querySelector('img:not(.gsc-label)');
      }
      if (!img || img.closest(SKIP)) continue;
      var box = img.closest('.sb-card__media') || img.parentElement;
      if (!box || box.querySelector(':scope > .gsc-label')) continue;
      if (box.getBoundingClientRect().width && box.getBoundingClientRect().width < 120) continue;
      if (getComputedStyle(box).position === 'static') box.classList.add('gsc-rel');
      box.classList.add('gsc-labelled');
      box.appendChild(makeLabel(false));
    }
  }

  /* 2 · eligible product page */
  var pts = [[6,14,3,.2,11],[14,62,2,4.1,13],[21,30,3,7.3,10],[27,78,2,1.6,12.5],[33,20,2,9.8,14],[39,54,3,3.2,11.5],[46,9,2,6.4,13],[52,70,3,.9,10.5],[58,36,2,8.7,12],[64,84,2,2.5,14.5],[70,16,3,5.5,11],[76,58,2,10.4,13.5],[82,28,3,1.1,12],[88,74,2,7.9,10],[93,44,3,4.7,13],[11,40,2,12.2,15],[61,50,2,11.3,12.5],[85,8,2,13.1,14]];
  function twinkles(host, extra, shift) {
    if (!host || host.querySelector(':scope > .gsc-twinkles')) return;
    if (getComputedStyle(host).position === 'static') host.classList.add('gsc-tw-host');
    var l = document.createElement('div');
    l.className = 'gsc-twinkles ' + extra;
    l.setAttribute('aria-hidden', 'true');
    pts.forEach(function (p, n) {
      var i = document.createElement('i');
      var d = shift ? ((n * 1.7) % 9).toFixed(1) : p[3];
      i.style.cssText = 'left:' + p[0] + '%;top:' + p[1] + '%;width:' + p[2] + 'px;height:' + p[2] + 'px;animation-delay:' + d + 's;animation-duration:' + p[4] + 's';
      l.appendChild(i);
    });
    host.appendChild(l);
  }
  function productPage() {
    if (C.pdp !== 'full' && C.pdp !== 'mixed') return;
    var stage = document.querySelector('.nmpd-gallery__stage');
    if (stage && !stage.querySelector(':scope > .gsc-label')) {
      stage.classList.add('gsc-labelled');
      var lab = makeLabel(true); lab.loading = 'eager';
      stage.appendChild(lab);
    }
    var price = document.querySelector('.nmpd-price');
    var tag = document.getElementById('gsc-tpl-tag');
    if (price && tag && !document.querySelector('.gsc-tag')) price.parentNode.insertBefore(tag.content.cloneNode(true), price.nextSibling);
    var wrap = document.querySelector('.nmpd-wrap');
    var main = wrap && wrap.closest('[id^="shopify-section"]');
    twinkles(main, 'gsc-twinkles--main', false);
    twinkles(document.querySelector('.nimbus-footer'), 'gsc-twinkles--footer', true);
    var band = document.getElementById('gsc-tpl-band');
    if (main && band && !document.querySelector('.gsc-band')) {
      var holder = document.createElement('div');
      holder.className = 'gsc-band-wrap';
      holder.appendChild(band.content.cloneNode(true));
      main.parentNode.insertBefore(holder, main.nextSibling);
      var shop = holder.querySelector('.gsc-shop');
      if (shop) shop.addEventListener('click', function (e) {
        e.preventDefault();
        var atc = document.querySelector('.nmpd-atc') || document.querySelector('form[action*="/cart/add"] [type="submit"]');
        if (atc) atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); else window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
    if (C.pdp === 'mixed') {
      var last = null;
      var check = function () {
        var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var id = input ? String(input.value) : '';
        if (id === last) return;
        last = id;
        document.documentElement.classList.toggle('gsc-variant-off', C.mixedIds.indexOf(',' + id + ',') === -1);
      };
      check();
      document.addEventListener('change', check, true);
      document.addEventListener('click', function () { setTimeout(check, 60); }, true);
      setInterval(check, 500);
    }
  }

  var queued = false;
  function scan() { queued = false; labelCards(); }
  function queue() { if (!queued) { queued = true; setTimeout(scan, 150); } }

  function start() {
    productPage();
    labelCards();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
